// extracted by mini-css-extract-plugin
module.exports = {"message-container":"message_message-container__8zKcW","error-message-box":"message_error-message-box__1Gnhu","success-message-box":"message_success-message-box__2xqTC"};